module.exports = __webpack_public_path__ + "static/media/contract-farming.7ecd8d11.svg";